import React from 'react';
import ReactDOM from 'react-dom';
import BillSelectionTotal from './BillSelectionTotal';

const BillSelectionPortal = (props) => {
  return ReactDOM.createPortal(
    <BillSelectionTotal {...props} />,
    document.body
  );
};

export default BillSelectionPortal; 